import { EffectDef, makeGain } from './types';

/** Sample-rate reduction + bit-depth quantization (AudioWorklet). */
export const bitcrusher: EffectDef = {
  type: 'bitcrusher',
  name: 'Bitcrusher',
  params: [
    { key: 'sampleRate', label: 'Rate', min: 1, max: 100, default: 20, step: 1 },
    { key: 'bits', label: 'Bits', min: 1, max: 16, default: 8, step: 1 },
    { key: 'wet', label: 'Wet', min: 0, max: 1, default: 0.8, step: 0.01 },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);
    const dry = makeGain(ctx, 1 - p.wet);
    const wetIn = makeGain(ctx, 1);
    const node = new AudioWorkletNode(ctx, 'bitcrusher-processor');
    const wetOut = makeGain(ctx, p.wet);

    input.connect(dry);
    dry.connect(output);
    input.connect(wetIn);
    wetIn.connect(node);
    node.connect(wetOut);
    wetOut.connect(output);

    const apply = (params: Record<string, number>) => {
      node.port.postMessage({ sampleRate: params.sampleRate, bits: params.bits });
      dry.gain.value = 1 - params.wet;
      wetOut.gain.value = params.wet;
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        node.disconnect();
        dry.disconnect();
        wetIn.disconnect();
        wetOut.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};